import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AslibLoadingService } from '@aslib/loading';
import { AslibModalComponent, AslibModalService } from '@aslib/modal';

// Helper compatível com Angular 5 para marcar todos os controles como touched
function markAllControlsAsTouched(control: AbstractControl): void {
  if (control instanceof FormGroup) {
    const controlsObj = (control as FormGroup).controls;
    const keys = Object.keys(controlsObj);
    for (let i = 0; i < keys.length; i++) {
      markAllControlsAsTouched(controlsObj[keys[i]]);
    }
  } else if (control instanceof FormArray) {
    const arr = control as FormArray;
    for (let i = 0; i < arr.length; i++) {
      markAllControlsAsTouched(arr.at(i));
    }
  }
  control.markAsTouched();
  control.updateValueAndValidity({ onlySelf: true, emitEvent: false });
}

@Component({
  selector: 'sarf-detalhe-municipio-apto',
  templateUrl: './detalhe-municipio.component.html'
})
export class DetalheMunicipioComponent  implements OnInit {
  @Input() municipioSelecionado: any; 
  @Output() onConfirm = new EventEmitter<any>();
  @Output() onClose = new EventEmitter<number>();
  formDetalhe: FormGroup;
  msgDtinicioInvalida: string = "";
  constructor( protected readonly fb: FormBuilder,
    private readonly aslibModalService: AslibModalService
  ) {}

  ngOnInit() {
    this.criarFormulario();
    this.atualizarFormulario();
  }

  exibirError(mensagem:string){
    new AslibModalComponent(this.aslibModalService).open(
      {
        title: 'Mensagem',
        text: mensagem,
        type: 'Info',
        windowClass: 'modalAlterado',
      }
    );
  } 

get obsLength(): number {
  const ctrl = this.formDetalhe && this.formDetalhe.get('observacao');
  const val = ctrl && ctrl.value;
  return (val && val.length) ? val.length : 0;
}


  criarFormulario() {
    this.formDetalhe = this.fb.group({
      municipio: this.fb.control({value: '', disabled: true}),
      dtIni: this.fb.control({value: '', disabled: false}),
      dtFim: this.fb.control({value: '', disabled: false}),
      observacao: this.fb.control({value: '', disabled: false, validators: [Validators.maxLength(200)]}),
    });
  }

  atualizarFormulario() {
    this.atualizarControle('municipio', this.municipioSelecionado.NomeMunicipio);
    this.atualizarControle('dtIni', this.municipioSelecionado.DataInicioVigenciaFormatada);
    this.atualizarControle('dtFim', this.municipioSelecionado.DataFimVigenciaFormatada);
    this.atualizarControle('observacao', this.municipioSelecionado.DescricaoObservacao);

   }

  atualizarControle(controle: string, value: any) {
    this.formDetalhe.get(controle).setValue(value === null || value === undefined ? '' : value.toString());
  }


  
/** Converte 'MM/YYYY' para [primeiroDiaDoMes, ultimoDiaDoMes] (Date locais, 00:00).
 *  Se 'mmyyyyFim' for nulo/undefined/string vazia, retorna end = null.
 */
monthRangeFromMmYyyy(
  mmyyyyIni: string,
  mmyyyyFim?: string | null
): { start: Date; end: Date | null; validacao: boolean } {

  // Aceita 'MM/YYYY' (com zero); troque por /^(0?[1-9]|1[0-2])\/(\d{4})$/ se quiser aceitar 'M/YYYY'
  var mmYyyyRegex = /^(0[1-9]|1[0-2])\/(\d{4})$/;

  // Normaliza entrada sem usar optional chaining
  var iniStr = (mmyyyyIni ? String(mmyyyyIni) : '').trim();
  var mIni = mmYyyyRegex.exec(iniStr);

  if (!mIni) {
   // this.exibirError("Formato inválido. Use 'MM/YYYY'. Valor recebido: '" + mmyyyyIni + "'");
    // Você pode lançar erro ou retornar algo padrão; aqui retorno um start inválido para sinalizar
    return { start: new Date(NaN), end: null, validacao: false };
  }

  var monthIni = parseInt(mIni[1], 10); // 01..12
  var yearIni  = parseInt(mIni[2], 10); // 4 dígitos

  // Início do mês (00:00 local)
  var start = new Date(yearIni, monthIni - 1, 1);

  // Se não houver fim informado (null/undefined/string vazia), retorna end = null
  if (mmyyyyFim == null || String(mmyyyyFim).trim() === '') {
    return { start: start, end: null, validacao: true };
  }

  var fimStr = String(mmyyyyFim).trim();
  var mFim = mmYyyyRegex.exec(fimStr);

  if (!mFim) {
    //this.exibirError("Formato inválido. Use 'MM/YYYY'. Valor recebido: '" + mmyyyyFim + "'");
    return { start: start, end: new Date(NaN), validacao: false };
  }

  var monthFim = parseInt(mFim[1], 10); // 01..12
  var yearFim  = parseInt(mFim[2], 10); // 4 dígitos

  // Último dia do mês (local): dia 0 do mês seguinte
  const end = new Date(yearFim, monthFim, 0);

  return { start, end, validacao: true };
}
  
validaDataIncial(){
  var operador = true;
  const raw = this.formDetalhe.getRawValue();
  this.msgDtinicioInvalida = "Data de Início de Vigência inválida";

    const { start: mesInicio, end: mesFim, validacao:valida } = this.monthRangeFromMmYyyy(raw.dtIni, raw.dtFim);

    if(!valida){
      if(isNaN(mesInicio.getTime())){
        raw.dtIni = null;
      }
      if(mesFim!= null && isNaN(mesFim.getTime())){
        this.msgDtinicioInvalida = "Data de Fim de Vigência inválida";
        raw.dtFim = null;
      }
      operador = false;
    }
  
  return operador;
}

validarDtiniDtFim(){
  var operador = true;
  const raw = this.formDetalhe.getRawValue();
  this.msgDtinicioInvalida = "Data de Fim de Vigência menor que Data de Início de Vigência";
  
    if(raw.dtFim){
        const { start: mesInicio, end: mesFim, validacao:valida } = this.monthRangeFromMmYyyy(raw.dtIni, raw.dtFim);
        const mesInicioTime = mesInicio.getTime();
        const mesFimTime = mesFim ? mesFim.getTime() : null;

      if(mesFimTime && mesInicioTime && mesFimTime < mesInicioTime){
        operador = false;
      }
    }
    
  
  return operador;
}

private buildPayload(): any {
    const raw = this.formDetalhe.getRawValue(); // inclui desabilitados
    // Normaliza valorDistribuido
    const valorStr = (raw && raw.valorDistribuido != null) ? String(raw.valorDistribuido).trim() : '';
  
    // Pega id com fallback
    var SequencialMunicipioAptoRecebimentoRoyalty = null;
    if (this.municipioSelecionado) {
      if (this.municipioSelecionado.SequencialMunicipioAptoRecebimentoRoyalty != null) {
        SequencialMunicipioAptoRecebimentoRoyalty = this.municipioSelecionado.SequencialMunicipioAptoRecebimentoRoyalty;
      } else if (this.municipioSelecionado.SequencialMunicipioAptoRecebimentoRoyalty != null) {
        SequencialMunicipioAptoRecebimentoRoyalty = this.municipioSelecionado.SequencialMunicipioAptoRecebimentoRoyalty;
      }
    }

    // Pega id com fallback
    var CodigoMunicipio = null;
    if (this.municipioSelecionado) {
      if (this.municipioSelecionado.CodigoMunicipio != null) {
        CodigoMunicipio = this.municipioSelecionado.CodigoMunicipio;
      } else if (this.municipioSelecionado.CodigoMunicipio != null) {
        CodigoMunicipio = this.municipioSelecionado.CodigoMunicipio;
      }
    }

    var DataInicioVigencia = (raw && raw.dtIni != null) ? raw.dtIni : '';
    var DataFimVigencia = (raw && raw.dtFim != null) ? raw.dtFim : '';
    var DescricaoObservacao = (raw && raw.observacao != null) ? raw.observacao : '';

    return {
      CodigoMunicipio: CodigoMunicipio,
      SequencialMunicipioAptoRecebimentoRoyalty: SequencialMunicipioAptoRecebimentoRoyalty,
      DataInicioVigencia: DataInicioVigencia,
      DataFimVigencia: DataFimVigencia,
      DescricaoObservacao: DescricaoObservacao
    };
  }

  fechar(){
    this.onClose.emit(2);
  }
 confirmar() {
    markAllControlsAsTouched(this.formDetalhe);
    if (this.formDetalhe.invalid) {
      this.exibirError("Data Início Vigência é obrigatória.");
      return;
    }

      if(!this.validaDataIncial()){
        this.exibirError(this.msgDtinicioInvalida);
        return;
      }
      if(!this.validarDtiniDtFim()){
        this.exibirError(this.msgDtinicioInvalida);
        return;
      }

    const payload = this.buildPayload();
    this.onConfirm.emit(payload);
  }

}



// WEBPACK FOOTER //
// ./src/app/royalts/cadastra-municipios-aptos/detalhe-muncipio/detalhe-municipio.component.ts